import global   from "@/prototype/global.js";

const log = global.log.getLogger("f_mtac.utils.RateCap");
log.setLevel(log.levels.WARN);

const RateCap = function(handler, dt_min) {
    var timer = undefined;
    var t = Date.now();
    this.poll = () => {
        log.debug("RateCap.poll");
        var dt = Date.now() - t;
        if (dt > dt_min) {
            t = Date.now();
            handler();
            return;
        }
        if (typeof timer === "number") {
            return;
        }
        timer = window.setTimeout(() => {
            t = Date.now();
            handler();
            timer = undefined;
        }, dt_min);
    };
    this.fire = () => {
        if (typeof timer === "number") {
            return;
        }
        window.clearTimeout(timer);
        t = Date.now();
        handler();
        timer = undefined;
    };
    this.reset = () => {
        window.clearTimeout(timer);
        t = Date.now();
        timer = undefined;
    };
    this.launch = () => {
        handler();
    };
};

export default RateCap;
